import { connect } from 'react-redux';
import {
  getAccountNotes,
  addAccountNotes,
  getCallLogList,
  addCallLog,
  getQuoteById,
  addCommercialProposal,
  addInnerCommercialProposal,
  updateInnerCommercialProposal,
  getCommercialProposal,
  getCommercialProposalById,
  patchCommercialProposal,
  sendProposalMail,
  getProposalPdf,
  checkEmail,
  deleteProposalLineItems,
  getBDA,
  deleteInnerProposal,
  getRepresentativeList,
  updateCallLog,
  editFieldOffice
} from '../../../../Action';
import ProposalDetail from "../Component/ProposalDetail";

const mapStateToProps = (state) => {
  const {
    AccountNotes,
    CallLog,
    CommercialProposal,
    RepresentativeList,
    EditFieldOffice
  } = state;

  return {
    AccountNotes,
    CallLog,
    CommercialProposal,
    RepresentativeList,
    EditFieldOffice
  }
}

const actionCreators = {
  getCallLogList,
  addCallLog,
  getAccountNotes,
  addAccountNotes,
  getQuoteById,
  addCommercialProposal,
  addInnerCommercialProposal,
  updateInnerCommercialProposal,
  getCommercialProposal,
  getCommercialProposalById,
  patchCommercialProposal,
  sendProposalMail,
  getProposalPdf,
  checkEmail,
  deleteProposalLineItems,
  deleteInnerProposal,
  getBDA,
  getRepresentativeList,
  updateCallLog,
  editFieldOffice
}
export default (connect(mapStateToProps, actionCreators)(ProposalDetail));